// src/components/cards/card-main-news.tsx
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const Image = dynamic(import('src/components/image'));

type Props = {
  data: any;
  showTitle?: boolean;
  showCategory?: boolean;
  showBlurb?: boolean;
  eventDataLayer?: any;
  aspectRatio?: string;
  vertical_image?: boolean;
  priority?: boolean;
  type?: 'FEATURE_IMAGE' | 'COVER_IMAGE' | 'CARD_LARGE' | 'CARD_MEDIUM' | 'CARD_SMALL' | 'NEXT_IMAGE' | string;
};

const CardMainNews = ({ data, showTitle = true, priority = true, showCategory = true, showBlurb = false, eventDataLayer = {}, aspectRatio = '16/9', type, vertical_image = false }: Props) => {
  if (isEmpty(data)) return null;
  return (
    <CardWrapper className='card-main-news' $aspectRatio={aspectRatio}>
      <a href={data?.link || data?.a || '#'} onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}>
        <div className='card-thumb'>
          <Image
            type={type}
            priority={priority}
            image={vertical_image ? (data?.vertical_image ? data?.vertical_image : data?.image) : data?.image}
            title={data?.title}
            decorative={Boolean(showTitle)}
          />
        </div>
        {(showCategory && data?.subCategory?.th) || showTitle || (showBlurb && data?.blurb) ? (
          <div className='card-content'>
            {showCategory && data?.subCategory?.th && <span className='category'>{data?.subCategory?.th}</span>}
            {showTitle && <div className='title'>{data?.title}</div>}
            {showBlurb && data?.blurb && <p className='blurb'>{data?.blurb}</p>}
          </div>
        ) : null}
      </a>
    </CardWrapper>
  );
};

const CardWrapper = styled.div<{ $aspectRatio: string }>`
  position: relative;
  display: block;
  border-radius: 5px;
  overflow: hidden;

  a {
    display: block;
    text-decoration: none;
  }

  &:hover {
    .card-thumb img {
      transform: scale(1.05);
    }
    .title {
      color: #ed1a3b;
    }
  }

  .card-thumb {
    position: relative;
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
    overflow: hidden;

    .resolution-image,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
  }

  .card-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 100px 20px 10px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));

    .category {
      display: inline-block;
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
      text-transform: uppercase;
      border-left: 2px solid #ed1a3b;
      padding-left: 5px;
      line-height: 1.5;
    }

    .title {
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.4;
      margin: 0;
      transition: color 0.3s ease;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }

    .blurb {
      color: #ccc;
      font-size: 14px;
      margin: 8px 0 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;

export default CardMainNews;
